import { Link } from 'react-router-dom';
import type { Referral } from '../../shared/types';
import { StatusChip } from './StatusChip';
import { formatDateTime } from '../lib/format';

export function ReferralRow({
  referral,
  to,
  plumberView = false,
}: {
  referral: Referral;
  to: string;
  plumberView?: boolean;
}) {
  return (
    <Link to={to} className="card" style={{ display: 'block', textDecoration: 'none', color: 'inherit' }}>
      <div className="row" style={{ justifyContent: 'space-between' }}>
        <strong style={{ color: 'var(--navy)' }}>{referral.customerName}</strong>
        <StatusChip status={referral.status} plumberView={plumberView} />
      </div>
      <p className="muted" style={{ margin: '0.25rem 0 0' }}>
        {referral.refNumber} · {formatDateTime(referral.createdAt)}
      </p>
      <p className="muted" style={{ margin: '0.25rem 0 0' }}>
        {referral.customerAddress}
      </p>
    </Link>
  );
}
